import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface AdFilterContainerProps {
  children?: React.ReactNode;
}

export default function AdFilterContainer({ children }: AdFilterContainerProps) {
  const { user } = useAuth();

  return (
    <div className="col-lg-3">
      <div className="d-flex flex-column">
        <div className="flex-shrink-0">
          {user && (
            <Link className="btn btn-primary w-100 mb-2" to="/teknik-destek">
              <i className="fas fa-tools me-2" />
              Teknik Destek
            </Link>
          )}
          <Link className="btn btn-primary w-100 mb-4" to="/gonderiler">
            <i className="fas fa-video me-2" />
            Gönderiler
          </Link>
        </div>
        {children}
      </div>
    </div>
  );
}
